import React from "react";
import { ActionButton } from "./ActionButton";

export function SubmitButton({
  text = "Submit",
  label,
  children,
  color = "blue",
  ...restProps
}) {
  const displayText = text || label || children || "Submit";

  return <ActionButton text={displayText} color={color} {...restProps} />;
}

export default SubmitButton;
